/** sessionStorage access that survives private browsing / restricted WebViews. */
export function getSessionStorageItem(key: string): string | null {
    try {
        return sessionStorage.getItem(key);
    } catch {
        return null;
    }
}

export function setSessionStorageItem(key: string, value: string): void {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        /* storage disabled or insecure context */
    }
}
